import Picture from "@/components/common/Picture";
import TextField from "@/components/site-builder/TextField";
import { type ExtendedUploadedImage } from "@/types";
import { type SiteBuilderModuleTextField } from "@/types/site-builder";
import s from "./RevealableBlock.module.scss";

interface RevealableBlockProps {
  text: SiteBuilderModuleTextField;
  image: ExtendedUploadedImage;
  open: boolean;
}

export default function RevealableBlock(props: RevealableBlockProps) {
  const { text, image, open } = props;

  return (
    <div data-open={open} className={s.wrapper}>
      <TextField field={text} type="text-regular" />
      <Picture imageConfig={image} className={s.image} baseBorderRadius />
    </div>
  );
}
